module.exports = __webpack_public_path__ + "static/media/84.769c0b3e.png";